import { isNil } from 'ramda';
import resetPasswordTemplate from './resetPassword.tpl.html';

export class ResetPassword {
  constructor($scope, $ngRedux, actionsFactory, notie, $state) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      notie,
      $state,
    });
    this.unsubscribe = $ngRedux.connect(ResetPassword.mapStateToThis, actionsFactory)(this);
  }

  $onInit() {
    this.password = null;
    this.passwordConfirmation = null;
    this.showResetRequestForm = this.shouldShowRequestResetForm();
    this.showResetPasswordForm = !this.showResetRequestForm;
    if (this.showResetPasswordForm) {
      const { token, email } = this.$state.params;
      this.email = email;
      this.token = token;
      this.validateResetPasswordTokenRequest(token, email);
    }
  }

  $onDestroy() {
    this.unsubscribe();
    this.initialiseResetPasswordProcess();
  }

  shouldShowRequestResetForm() {
    const { token, email } = this.$state.params;
    return isNil(token) && isNil(email);
  }

  backToLogin() {
    this.state('not-authenticated.login');
  }

  static mapStateToThis(state) {
    return {
      reset: state.passwordReset,
    };
  }

  submitResetRequest() {
    this.requestResetPasswordRequest(this.email);
  }

  submitPassword() {
    this.resetPasswordRequest(
      this.token, this.email, this.password, this.passwordConfirmation);
  }
}

ResetPassword.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  'notie',
  '$state',
];

export const resetPassword = {
  template: resetPasswordTemplate,
  controller: ResetPassword,
};
